import { withLazyRoute } from '@/components/Lazy/LazyRouteWrapper'
import React from 'react'

export const DepreciationCalculator = withLazyRoute(
  React.lazy(() => import('./GrayBook/DepreciationCalculator')),
  'Loading gray book...',
)

export const DepreciationFormulas = withLazyRoute(
  React.lazy(() => import('./GrayBook/DepreciationFormulas')),
  'Loading depreciation formulas...',
)

export const MessageLog = withLazyRoute(
  React.lazy(() => import('./Messages')),
  'Loading message log...',
)

export const VINDecoder = withLazyRoute(
  React.lazy(() => import('./VINDecoder')),
  'Loading VIN decoder...',
)

export const ShipmentCalculator = withLazyRoute(
  React.lazy(() => import('./ShipmentCalculator')),
  'Loading shipment calculator...',
)

export const AuditLog = withLazyRoute(
  React.lazy(() => import('./AuditLog')),
  'Loading audit log...',
)

export const LTVCalculator = withLazyRoute(
  React.lazy(() => import('./GrayBook/LTVCalculator')),
  'Loading LTV calculator...',
)
